const notyAlert = {
    alert: function (text, type = 'danger', options = {}) {
        options.timeout = (typeof(options.timeout) != "undefined") ? options.timeout : 5000;
        options.onClose = (typeof(options.onClose) != "undefined") ? options.onClose : null;
        noty({
            text: text,
            type: type,
            dismissQueue: true,
            layout: 'top',
            timeout: options.timeout,
            onClose: options.onClose
        });
    },
}

export default notyAlert;